var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backInfoPc",on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":require("../../assets/image/team-bak.png"),"alt":""}}),_c('div',{staticClass:"text fOR"},[_vm._v("Back")])])}
var staticRenderFns = []

export { render, staticRenderFns }